import { makeStyles } from 'tss-react/mui';

interface StyleParams {
  isCollapsed: boolean;
}
export const useSidebarNavItemStyles = makeStyles<StyleParams>()((theme, { isCollapsed }) => ({
  button: {
    width: isCollapsed ? '28px' : '100%',
    flexGrow: 0,
    minHeight: theme.spacing(2.5),
    paddingTop: theme.spacing(0.25),
    paddingBottom: theme.spacing(0.25),
    color: theme.palette.text.secondary,
    transition: theme.transitions.create(['width'], {
      duration: theme.transitions.duration.shorter,
      easing: theme.transitions.easing.sharp,
    }),
    '&:hover': {
      color: theme.palette.text.primary,
      backgroundColor: theme.palette.custom.layout.shell.buttonHover,
    },
    '&.Mui-selected': {
      color: theme.palette.text.primary,
      backgroundColor: theme.palette.custom.layout.shell.buttonSelected,
      '&:hover': {
        backgroundColor: theme.palette.custom.layout.shell.buttonSelected,
      },
      '& .MuiListItemText-primary': {
        fontWeight: theme.typography.fontWeightMedium,
      },
    },
  },
  icon: {
    color: 'inherit',
    marginRight: isCollapsed ? 0 : theme.spacing(1),
    transition: theme.transitions.create('margin-right', {
      duration: theme.transitions.duration.shorter,
      easing: theme.transitions.easing.sharp,
    }),
  },
  text: {
    opacity: isCollapsed ? 0 : 1,
    maxWidth: isCollapsed ? 0 : 200,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    transition: theme.transitions.create(['opacity', 'max-width'], {
      duration: theme.transitions.duration.shorter,
      easing: theme.transitions.easing.sharp,
    }),
    '& .MuiListItemText-primary': {
      color: 'inherit',
    },
  },
  newChip: {
    flexShrink: 0,
    marginLeft: theme.spacing(1),
    backgroundColor: theme.palette.accent.main,
    color: theme.palette.accent.contrastText,
  },
}));
